import Script from 'next/script'
import { FC } from 'react'

type NeuroIdScriptProps = {
  flow: 'prequal' | 'appflow'
}

const NeuroIdScript: FC<NeuroIdScriptProps> = ({ flow }) => (
  <Script id="neuro-id" data-testid="neuro-id" strategy="afterInteractive">
    {`(function(n,e,u,r,o,i,d){
      n.nid=n.nid||function(){(n.nid.q=n.nid.q||[]).push(arguments)};
      o=e.createElement(u);i=e.getElementsByTagName(u)[0];o.async=1;
      o.src=r;i.parentNode.insertBefore(o,i);
    })(window,document,'script','${
      flow === 'prequal'
        ? process.env.NEXT_PUBLIC_NEUROID_PREQUAL_JS_SCRIPT
        : process.env.NEXT_PUBLIC_NEUROID_APP_FLOW_JS_SCRIPT
    }')`}
  </Script>
)

export default NeuroIdScript
